import PageAdditionalControlsContainer from './PageAdditionalControlsContainer';

export default PageAdditionalControlsContainer;